<div class="container m-b-20" fxLayout="row" fxLayoutAlign="end" fxLayoutGap="20px">
  <button
    mat-raised-button
    color="primary"
    [routerLink]="['create']"
    *mifosxHasPermission="'VIEW_ALL_PROVISIONING_ENTRIES'"
  >
    <fa-icon icon="plus" class="m-r-10"></fa-icon>
    {{ 'labels.buttons.Create Provisioning Entry' | translate }}
  </button>
</div>

<div class="container">
  <div fxLayout="row">
    <mat-form-field fxFlex>
      <mat-label>{{ 'labels.inputs.Filter' | translate }}</mat-label>
      <input matInput (keyup)="applyFilter($event.target.value)" />
    </mat-form-field>
  </div>

  <div class="mat-elevation-z8">
    <table mat-table [dataSource]="dataSource" matSort>
      <ng-container matColumnDef="createdUser">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Created By' | translate }}</th>
        <td mat-cell *matCellDef="let provisioningEntry">{{ provisioningEntry.createdUser }}</td>
      </ng-container>

      <ng-container matColumnDef="createdDate">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'labels.inputs.Created On' | translate }}</th>
        <td mat-cell *matCellDef="let provisioningEntry">{{ provisioningEntry.createdDate }}</td>
      </ng-container>

      <ng-container matColumnDef="journalEntry">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ 'labels.inputs.Journal Entry Created' | translate }}
        </th>
        <td mat-cell *matCellDef="let provisioningEntry">
          <mat-checkbox [disabled]="true" [checked]="provisioningEntry.journalEntry"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="viewReport">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.View Report' | translate }}</th>
        <td mat-cell *matCellDef="let provisioningEntry">
          <button mat-button color="primary" [routerLink]="['view', provisioningEntry.id]">
            <fa-icon icon="eye" class="m-r-10"></fa-icon>{{ 'labels.buttons.View' | translate }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="recreateProvisioning">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.Recreate Provisioning' | translate }}</th>
        <td mat-cell *matCellDef="let provisioningEntry">
          <button
            mat-button
            (click)="recreateProvisioning($event, provisioningEntry.id)"
            [disabled]="provisioningEntry.journalEntry"
            color="primary"
          >
            <fa-icon icon="edit" class="m-r-10"></fa-icon>{{ 'labels.buttons.Recreate' | translate }}
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="viewJournalEntry">
        <th mat-header-cell *matHeaderCellDef>{{ 'labels.inputs.View Journal Entry' | translate }}</th>
        <td mat-cell *matCellDef="let provisioningEntry">
          <button
            mat-button
            (click)="viewJournalEntry($event, provisioningEntry.id)"
            [disabled]="!provisioningEntry.journalEntry"
            color="primary"
          >
            <fa-icon icon="eye" class="m-r-10"></fa-icon>{{ 'labels.buttons.View' | translate }}
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>

    <mat-paginator [pageSizeOptions]="[10, 25, 50, 100]" showFirstLastButtons></mat-paginator>
  </div>
</div>
